import React, { useEffect } from "react";
import RoboGolfTemplate from "../../../Templetes/Categories/Details/RoboGolf/RoboGolf.template";

const RoboGolfPage = () => {
  useEffect(() => {
    document.title = "Internatioal Robot Challenge - RoboGolf";
  }, []);
  return <RoboGolfTemplate />;
};

export default RoboGolfPage;
